import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-transactions-icon',
  templateUrl: './lib-transactions-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibTransactionsIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
